module.exports = __webpack_public_path__ + "static/leftHand.543b00be.png";